import 'owl.carousel';

jQuery(document).ready(function($) {
    const $hamburger = $('.hamburger');
    const $mobileMenu = $('#mobile-menu');
    const $menuOverlay = $('#mobile-menu-overlay');
    const $menuItems = $('#mobile-menu .menu-item-has-children > a');
    const $arrows = $('#mobile-menu .custom-arrow');
    let isFirstSubmenuOpened = false;

    function toggleMenu() {
        $hamburger.toggleClass('open');
        $mobileMenu.toggleClass('open');
        $menuOverlay.toggleClass('open');
    
        if (!$mobileMenu.hasClass('open')) {
            $('#mobile-menu .sub-menu').css('transform', 'translateX(100%)').removeClass('open');
            $('#mobile-menu .menu-item-has-children').removeClass('open');
            $('.open-arrow').hide();
            $('.closed-arrow').show();
        }
    }

    $hamburger.on('click', toggleMenu);
    $menuOverlay.on('click', toggleMenu);

    $menuItems.on('click', function(e) {
        e.preventDefault();
    
        const $parentItem = $(this).closest('.menu-item');
        const $submenu = $parentItem.children('.sub-menu').first();
        const $arrow = $(this).find('.custom-arrow');
    
        if ($submenu.hasClass('open')) {
            $submenu.removeClass('open').css('transform', 'translateX(100%)');
            $arrow.find('.open-arrow').hide();
            $arrow.find('.closed-arrow').show();
            $arrow.find('.open-arrow, .closed-arrow').css('transform', 'rotate(180deg)');
        } else {
            $submenu.addClass('open').css('transform', 'translateX(0)');
            $arrow.find('.open-arrow').show();
            $arrow.find('.closed-arrow').hide();
            $arrow.find('.open-arrow, .closed-arrow').css('transform', 'rotate(0)');
        }
    });
    

    $('.mobile-menu .sub-menu').each(function() {
        const $submenu = $(this);
        const backButtonText = $('#back-button-text').text(); 
        const $backBtn = $('<li class="back"><a href="#">' + backButtonText + '</a></li>');
        $submenu.prepend($backBtn);
        $backBtn.on('click', function(e) {
            e.preventDefault();
            const $parentItem = $submenu.parent();
            const $openArrow = $parentItem.find('.open-arrow').first();
            const $closedArrow = $parentItem.find('.closed-arrow').first();
    
            $submenu.css('transform', 'translateX(100%)');
            setTimeout(() => {
                $submenu.removeClass('open');
                $parentItem.removeClass('open');
                $openArrow.hide();
                $closedArrow.show();
            }, 300);
        });
    });
});

$(document).ready(function() {
    const dropdowns = $('.menu-item').not('.mobile-menu .menu-item').not('.dropdown-menu .menu-item');
    let timer;

    dropdowns.each(function() {
        const dropdown = $(this);
        const navbar = $('.navbar')
        const dropdownButton = dropdown.find('a');
        const dropdownMenu = dropdown.find('.dropdown-menu');

        dropdown.on('mouseenter', function() {
            clearTimeout(timer);
            navbar.addClass('sticky-top');

            $('.dropdown-menu').not(dropdownMenu).removeClass('open').fadeOut(300); 

            dropdown.addClass('open');

            if (!dropdownMenu.hasClass('open')) {
                dropdownMenu.stop(true, true).fadeIn(300).addClass('open');
            }

            if (dropdownMenu.find('.menu-item-object-kategorie_produktow').length > 0) {
                
                dropdownMenu.css({
                    top: 84,
                    left: 0,
                    width: '100vw',
                    display: 'flex'
                });
            } else {
                
                const dropdownOffset = dropdown.offset(); 
                dropdownMenu.css({
                    top: 84,
                    left: dropdownOffset.left, 
                    width: 'auto', 
                    display: 'flex'
                });
            }
        });

        dropdown.on('mouseleave', function() {
            timer = setTimeout(function() {
                dropdown.removeClass('open');
                dropdownMenu.stop(true, true).fadeOut(300).removeClass('open');
            }, 200);
        });

        dropdownButton.on('click', function(e) {
            if (!$(this).attr('href') || $(this).attr('href') === '#') {
                e.preventDefault(); 
            }
        });
    });
});

$(document).ready(function() {
    const dropdowns = $('.polylang-nav .menu-item').not('.mobile-menu .menu-item').not('.dropdown-menu .menu-item');
    let timer;

    dropdowns.each(function() {
        const dropdown = $(this);
        const dropdownButton = dropdown.find('a');
        const dropdownMenu = dropdown.find('.sub-menu');

        dropdown.on('mouseenter', function() {
            clearTimeout(timer);

            dropdown.addClass('open');

            if (!dropdownMenu.hasClass('open')) {
                dropdownMenu.stop(true, true).fadeIn(300).addClass('open');
            }

            const menuOffset = dropdownMenu.offset();
            const menuWidth = dropdownMenu.outerWidth();
            const windowWidth = $(window).width();
            const menuRight = menuOffset.left + menuWidth;

            if (menuRight > windowWidth) {
                dropdownMenu.css({
                    left: windowWidth - menuWidth - 20
                });
            } else {
                dropdownMenu.css({
                    left: -10
                });
            }

            dropdownMenu.css({
                top: dropdown.outerHeight(),
            });
        });

        dropdown.on('mouseleave', function() {
            timer = setTimeout(function() {
                dropdown.removeClass('open');
                dropdownMenu.stop(true, true).fadeOut(300).removeClass('open');
            }, 500);
        });

        dropdownButton.on('click', function(e) {
            if (!$(this).attr('href') || $(this).attr('href') === '#') {
                e.preventDefault();
            }
        });
    });
});

jQuery(function ($) {
    $('.owl-category-menu').each(function () {
        var $carousel = $(this);
        var itemCount = $carousel.find('> li').length;

        var responsiveOptions = {
            0: 1,
            991: 3,
            1366: 3,
            1600: 4,
            1920: 5
        };

        function getCurrentItemsCount() {
            var width = $(window).width();
            var current = 1;

            Object.keys(responsiveOptions).forEach(function (breakpoint) {
                if (width >= breakpoint) {
                    current = responsiveOptions[breakpoint];
                }
            });

            return current;
        }

        function checkNavVisibility(event) {
            var originalItems = $carousel.find('.owl-item:not(.cloned)').length;
            var visibleItems = event.page.size;
            console.log(visibleItems);

            if (originalItems <= visibleItems) {
                $carousel.find('.owl-nav').hide();
            } else {
                $carousel.find('.owl-nav').show();
            }
        }

        $carousel.owlCarousel({
            margin: 20,
            drag: false,
            loop: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            nav: true,
            navText: [
                "<div class='custom-prev'><i class='bi bi-chevron-left'></i></div>",
                "<div class='custom-next'><i class='bi bi-chevron-right'></i></div>"
            ],
            dots: false,
            responsive: {
                0: { items: 1 },
                991: { items: 3 },
                1366: { items: 3 },
                1600: { items: 4 },
                1920: { items: 5 }
            },
            onInitialized: checkNavVisibility,
            onResized: checkNavVisibility
        });

        $carousel.trigger('refresh.owl.carousel');
    });
});

jQuery(function ($) {
    $('.mobile-menu .lang-item').first().addClass('lang-item--first');
});